import { getDefaultExportFromCjs as r } from "./_commonjsHelpers.js";
import { __require as o } from "../node_modules/js-logger/src/logger.js";
var e = o();
const a = /* @__PURE__ */ r(e);
export {
  a as default
};
//# sourceMappingURL=logger.js.map
